// extracted by mini-css-extract-plugin
export default {"inputText":"InputComponent_inputText__CxQcW","short":"InputComponent_short__b9eD1"};